/**
 * Central object used for Store App module
 */
// import { useI18n } from 'vue-i18n'
import type ISnackbar from '@/interfaces/internal/Snackbar'

interface AppState {
  config: {
    APP_NAME: string | null
    APP_ENV: string | null
    AUTH_PUBLIC_CLIENT_ID: string | null
    AUTH_BASE_URL: string | null
    DEV_BAR : boolean | null
    DARA_BASE_URL: string | null
    MYHQ_SPA_V3_BASE_URL: string | null
    MYCC_BASE_URL: string | null
    MYA_BASE_URL: string | null
    MY1C_BASE_URL: string | null
    GTM_ID: string | null
  }
  error: string | null
  leaveWarningModal: {
    active: boolean
    confirmed: boolean
    intendedRoute: string | undefined
    text: string | null
    title: string | null
  }
  studentSelectYearModal: boolean
  studentSetCurrentStudentModal: boolean
  snackbar: ISnackbar,
  locale: string | null
  $i18n: object
  theme: string | null
}

export const useAppStore = defineStore('app', {
  state: (): AppState => ({
    config: {
      APP_NAME: null,
      APP_ENV: null,
      AUTH_PUBLIC_CLIENT_ID: null,
      AUTH_BASE_URL: null,
      DEV_BAR: null,
      DARA_BASE_URL: null,
      MYHQ_SPA_V3_BASE_URL: null,
      MYCC_BASE_URL: null,
      MYA_BASE_URL: null,
      MY1C_BASE_URL: null,
      GTM_ID: null,
    },
    error: null,
    leaveWarningModal: {
      active: false,
      confirmed: false,
      intendedRoute: undefined,
      text: null,
      title: null,
    },
    studentSelectYearModal: false,
    studentSetCurrentStudentModal: false,
    snackbar: {
      colour: 'primary',
      multiLine: false,
      text: '',
      timeout: 8000,
      variant: 'elevated',
    },
    locale: null,
    $i18n: {},
    theme: null,
  }),

  getters: {
    daraApiBaseUrl: state => state.config.DARA_BASE_URL + '/api/myfj-v2',
  },

  actions: {
    setConfigs() {
      const metaEnv = import.meta.env
      this.config.APP_NAME = metaEnv.VITE_APP_NAME ?? null
      this.config.APP_ENV = metaEnv.VITE_APP_ENV ?? null

      this.config.DEV_BAR = metaEnv.VITE_DEV_BAR === 'true'

      this.config.AUTH_PUBLIC_CLIENT_ID = metaEnv.VITE_AUTH_PUBLIC_CLIENT_ID ?? null
      this.config.AUTH_BASE_URL = metaEnv.VITE_AUTH_BASE_URL ?? null

      this.config.DARA_BASE_URL = metaEnv.VITE_DARA_BASE_URL ?? null
      this.config.MYHQ_SPA_V3_BASE_URL = metaEnv.VITE_MYHQ_SPA_V3_BASE_URL ?? null
      this.config.MYCC_BASE_URL = metaEnv.VITE_MYCC_BASE_URL ?? null
      this.config.MYA_BASE_URL = metaEnv.VITE_MYA_BASE_URL ?? null
      this.config.MY1C_BASE_URL = metaEnv.VITE_MY1C_BASE_URL ?? null
      this.config.GTM_ID = metaEnv.VITE_GTM_ID ?? null
    },
    resetLeaveWarningModal() {
      this.leaveWarningModal = {
        active: false,
        confirmed: false,
        intendedRoute: undefined,
        text: null,
        title: null,
      }
    },
    setError(error: string) {
      this.error = error
    },
    setSnackbar(snackbar: ISnackbar) {
      this.snackbar = {
        colour: snackbar.colour ?? 'primary',
        multiLine: snackbar.multiLine ?? false,
        text: snackbar.text ?? '',
        timeout: snackbar.timeout ?? 8000,
        variant: snackbar.variant ?? 'elevated',
      }
    },
    setTheme(theme: string) {
      this.theme = theme
    },
  },
})
